module.exports = __webpack_public_path__ + "static/media/inter-regular.7c539936.woff";